export default __webpack_public_path__ + "static/media/52358815e408ce819577234552a37184.jpg";